import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { sanitizeMaxPcDistance } from "../usersPageHelpers";
import { FormPanelProps, FormSwitch, FormTextField } from "./formFields";

export function HosSettingsTab({ form, setField, isMobile }: FormPanelProps) {
  const { t } = useTranslation();
  const bind = { form, setField };
  const direction = isMobile ? "column" : "row";
  return (
    <Stack spacing={1.25}>
      <Stack direction={direction} spacing={1.25}>
        <FormTextField {...bind} field="authorityName" label={t("users.authorityName")} />
        <FormTextField {...bind} field="carrierNumber" label={t("users.carrierNumber")} />
      </Stack>
      <FormTextField {...bind} field="authorityAddress" label={t("users.authorityAddress")} />
      <TextField
        label={t("users.maxPcDistance")}
        value={form.maxPCDistancePerDay}
        onChange={event =>
          setField("maxPCDistancePerDay", sanitizeMaxPcDistance(event.target.value))
        }
        fullWidth
        size="small"
        type="number"
        inputProps={{ min: 0 }}
      />
      <Stack direction={direction} spacing={1.25}>
        <FormSwitch
          {...bind}
          field="isAdverseDrivingEnabled"
          label={t("users.isAdverseDrivingEnabled")}
        />
        <FormSwitch {...bind} field="isExemptHOSEnabled" label={t("users.isExemptHosEnabled")} />
      </Stack>
      <Stack direction={direction} spacing={1.25}>
        <FormSwitch
          {...bind}
          field="isPersonalConveyanceEnabled"
          label={t("users.isPersonalConveyanceEnabled")}
        />
        <FormSwitch {...bind} field="isYardMoveEnabled" label={t("users.isYardMoveEnabled")} />
      </Stack>
    </Stack>
  );
}
